
document.addEventListener("DOMContentLoaded", function () {
  // Handle both product types: .t4s-product and .gsw-prg-item
  document.querySelectorAll('.t4s-product, .gsw-prg-item ').forEach(function (productCard) {
    const isGlobo = productCard.classList.contains('gsw-prg-item');
    const titleEl = isGlobo
    ? productCard.querySelector('[data-title]')
    : productCard.querySelector('.t4s-product-title a');
    const imageEl = isGlobo
    ? productCard.querySelector('img') // Adjust if image has specific class
    : productCard.querySelector('.t4s-product-main-img');
    const ImageTitle = productCard.querySelector('.t4s-product-info__inner h3.t4s-product-title a');
    // const titleEl = productCard.querySelector('.t4s-product-title a');
    // const imageEl = productCard.querySelector('.t4s-product-main-img');
    const fullLinkEl = productCard.querySelector('a[data-pr-href]'); // <-- added line 
    // console.log('titleEl', titleEl);
  
     
    productCard.querySelectorAll('.cstm-swatch').forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        // Remove selected class from all swatches in this card 
        productCard.querySelectorAll('.cstm-swatch').forEach(s => s.classList.remove('selected'));
        // Add selected class to clicked swatch
        this.classList.add('selected');
        
        // Get color name from swatch class
        const swatchSpan = swatch.querySelector('.t4s-swatch__item');
        const classList = Array.from(swatchSpan.classList);
        const colorClass = classList.find(cls => cls.startsWith('bg_color_'));
        const colorName = colorClass ? colorClass.replace('bg_color_', '').replace(/-/g, ' ') : 'Unknown';

        // Update title text
        if (titleEl) {
          // const originalTitle = titleEl.dataset.originalTitle || titleEl.textContent.split(' - ')[0];
          // titleEl.dataset.originalTitle = originalTitle;
          // titleEl.textContent = `${originalTitle} - ${colorName}`;

          //  Update both links
          const newUrl = swatch.getAttribute('data-url');
          ImageTitle.setAttribute('href', newUrl);
          if (newUrl) {
            titleEl.setAttribute('href', newUrl);
            if (fullLinkEl) {
              fullLinkEl.setAttribute('href', newUrl);
            }
          }
        }

        // Replace image
        if($(this).hasClass("metaswatches")){
        }else{
        const imageUrl = swatch.getAttribute('data-image');
        console.log(imageUrl);
        if (imageUrl && imageEl) {
          imageEl.src = imageUrl;
          imageEl.setAttribute('data-src', imageUrl);

          // Build srcset string
          const widths = [100, 200, 330, 400, 500, 600, 700, 800, 900];
          const srcset = widths.map(w => `${imageUrl.replace(/width=\d+/, `width=${w}`)} ${w}w`).join(', ');

          imageEl.setAttribute('srcset', srcset);
          imageEl.setAttribute('data-srcset', srcset);
        }
      }
        
            
        productCard.querySelectorAll('#collectionsimilar-palette .available-shades-items').forEach(function (swatches) {
            var firstLink = swatches.querySelector("a"); 
              if ($(firstLink).hasClass("selected")) {
                var href = firstLink.getAttribute("href");             
                var pdpImage = firstLink.getAttribute("data-pdp-image");
                
                // Replace image
                const imageUrl = swatch.getAttribute('data-image');
                console.log(imageUrl);
                if (imageUrl && imageEl) {
                  imageEl.src = imageUrl;
                  imageEl.setAttribute('data-src', pdpImage);
        
                  // Build srcset string
                  const widths = [100, 200, 330, 400, 500, 600, 700, 800, 900];
                  const srcset = widths.map(w => `${imageUrl.replace(/width=\d+/, `width=${w}`)} ${w}w`).join(', ');
        
                  imageEl.setAttribute('srcset', pdpImage);
                  imageEl.setAttribute('data-srcset', pdpImage);
                }
                const newUrl = swatch.getAttribute('data-url');
                if (newUrl) {
                  titleEl.setAttribute('href', href);
                  if (fullLinkEl) {
                    fullLinkEl.setAttribute('href', href);
                  }
                }
              }
        });
      });

  });



    });
  var interval = setInterval(getColor, 500);
function getColor(){
  document.querySelectorAll('.t4s-product').forEach(product => {
    const itemLink = product.getAttribute('data-link');
    const items = product.querySelectorAll('.gsw-prg-item');
    const totalCount = items.length;
  
    items.forEach((item, index) => {
      if (index < 4) {
        item.classList.remove('hide-important');
      } else {
        item.classList.add('hide-important');
      } 
    });

    console.log(totalCount);
    if (totalCount > 4) {
      const alreadyAdded = product.querySelector('.globo-product-groups-collection .cstm-swatch.more-swatches');     
    
      console.log(alreadyAdded);
       if (!alreadyAdded) {
        const remaining = totalCount - 4;
        
         const link = document.createElement('a');
          link.href = itemLink;
          link.className = 'cstm-swatch more-swatches';
      
          const swatch = document.createElement('div');
          swatch.className = 'cst-color-swatch';
          swatch.textContent = `+${remaining}`;
      
          link.appendChild(swatch);
    
          const insertAfter = items[3]; console.log(items[3]);
          insertAfter.insertAdjacentElement('afterend', link);
      }
    }
    // Don't auto-click the first swatch so products shown as variants retain their own thumbnail
    // const firstLink = product.querySelector('.gsw-prg-item a.gsw-prg-item--link');
    // if (firstLink) {
    //   firstLink.click();
    // }
    if (totalCount > 0) {
      // console.log("totalCount"+totalCount);
      const $product = $(product);
      $product.find('.Saree_product_wrapper').addClass('hide-Saree-product');
    }

  });
  if(document.querySelector(".globo-product-groups-collection .gsw-prg-item")){
     // console.log("clearIntervali")
    clearInterval(interval);
  }else{
    setTimeout(function(){
      // console.log("clearInterval45")
     clearInterval(interval);
    }, 9000);
  }
}

  
});
document.addEventListener('click', function (e) {
  const link = e.target.closest('a.gsw-prg-item--link');
  if (link) {
    e.preventDefault();
    e.stopImmediatePropagation();

    var image = link.getAttribute('data-image');
    var title = link.getAttribute('data-title');
    var href = link.getAttribute('href');

    // console.log('Image:', image);
    // console.log('Title:', title);
    // console.log('Href:', href);
    $(link).closest(".t4s-product").find(".t4s-product-info .gsw-list-products-group .gsw-prg-item a.gsw-prg-item--link").removeClass("is-gsw-active");
    $(link).addClass("is-gsw-active");
    $(link).closest(".t4s-product").find(".t4s-product-inner .t4s-product-img img").attr("srcset", image);
    $(link).closest(".t4s-product").find(".t4s-product-inner .t4s-product-img img").attr("src", image);
     // $(link).closest(".t4s-product").find(".t4s-product-title a").text(title);
     $(link).closest(".t4s-product").find(".t4s-product-inner a.t4s-full-width-link").attr("href", href);
     $(link).closest(".t4s-product").find(".t4s-product-info__inner h3.t4s-product-title a").attr("href", href);
  }
});


$( "body" ).on( "click", '.collectionsimilar-shade', function( evt ) {
  evt.preventDefault();
   var $this = $(this);
    setTimeout(function() {
    // console.log("clicksw");
var attr = $this.attr("data-attr");
  attr = $.trim(attr).toUpperCase();
   // console.log(attr);
var type = $this.attr("data-curr-type");
   type = $.trim(type).toUpperCase();
var handle = $this.attr("data-handle");
       var mainImage = $this.parents(".t4s-product-wrapper").find(".t4s-product-inner .t4s-product-img img");
       var Imagelink = $this.parents(".t4s-product-wrapper").find(".t4s-product-inner a.t4s-full-width-link");
       var titlelink = $this.parents(".t4s-product-info__inner").find("h3.t4s-product-title a");
        var found = false;
  $(".available-all-shades .available-shade-palette .available-shades-items").each(function(){
    var attrMain = $(this).attr("data-type");
      var attrProductType = $(this).attr("data-product-type");
    if(attrMain === attr && attrProductType === type && !found){
       var image = $(this).find("a").attr("data-pdp-image");
       var link =  $(this).find("a").attr("href");
      console.log(link)
        mainImage.attr("src", image);
        mainImage.attr("srcset", image);
        Imagelink.attr("href", link);
        titlelink.attr("href", link);
        found = true;
        return false;
      } 
  });
}, 300);
});

$.ajax({
url: "https://twinbirds.co.in/collections/all/?view=available-shades&color=WHITE&productType=CHURIDHAR LEGGINGS COTTON&ppHandle=women-churidar-legging-cotton-mystic-pink",
cache: false,
success: function(html){
  $(".available-all-shades").html(html);
 }
});